const ALLOWED = ['ru', 'en', 'id'];

export class Lang {
  static getDefault() {
    return 'en';
  }

  static getBrowserLocale() {
    const browserLanguage = navigator.language;
    let output = browserLanguage;

    if (/-|_/.test(output)) {
      ['-', '_'].forEach((languageSparator) => {
        if (output.lastIndexOf(languageSparator) !== -1) {
          output = output.split(languageSparator)[0];
        }
      });
    }
    return output;
  }

  static isAllowed(val) {
    return ALLOWED.includes(`${val}`.toLowerCase());
  }
}
